import styled from '@emotion/styled';
import margins from '../../utils/caluclateMargins';

export const Wrapper = styled.div`
  position: relative;
`;

export const TextsWrapper = styled.div`
  ${margins}
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ fontSize }) => fontSize || 16}px;

  & div p {
    line-height: 1.5rem;
  };
  div {
    p > strong {
      margin-top: 3rem;
      display: block;
      padding-bottom: 0.5rem;
    };
  };
  & strong {
    font-weight: 600;
    font-size: ${({ fontSizeB }) => fontSizeB || 16}px;
    line-height: ${({ lineHeightB }) => lineHeightB || 24}px;
    
  };


`;

export const ImageWrapper = styled.div`
  position: absolute;
  bottom: ${({ theme }) => theme.vars.sectionPaddingBottomD};
  right: 0;
  max-width: 425px;
  width: 37%;

  ${({ theme }) => theme.media.tablet} {
    display: none;
  }
`;
